import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Button, useTranslations } from "@jti/ui";
export const RemoveCartItemButton = memo(({ onClick }) => {
    const { __ } = useTranslations();
    return (_jsx(Button, { color: "tertiary", onClick: onClick, "data-testid": "cartRemoveButton", "data-remove-button": true, children: __("cart.cart_item.button.remove") }));
});
//# sourceMappingURL=RemoveCartItemButton.js.map